import React, { useState, useEffect } from "react";
import { useAuth } from "../../../context/AuthContext";
import { getApiEndpoint } from "../../../config/config";
import { IconCalendarEvent } from "@tabler/icons-react";
import TeamEventsModal from "../TeamEventsModal/TeamEventsModal";
import "./TeamEventBubble.css";

function TeamEventBubble() {
  const { getVerifiedJWT } = useAuth();
  const [nextEvent, setNextEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    fetchNextEvent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getEventEndTime = event => {
    const scheduledTime = new Date(event.scheduled_time);
    const durationMinutes = Number(event.duration_minutes || 60);
    return new Date(scheduledTime.getTime() + durationMinutes * 60000);
  };

  const fetchNextEvent = async () => {
    try {
      setLoading(true);
      const jwt = await getVerifiedJWT();
      if (!jwt) return;

      const response = await fetch(
        getApiEndpoint("/v1/attendance/my-team-events"),
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt}`,
          },
        }
      );

      if (response.ok) {
        const result = await response.json();
        const eventsData = result.data?.events || [];

        // Keep events in Upcoming until their scheduled duration has ended
        const now = new Date();
        const upcomingEvents = eventsData
          .filter(event => getEventEndTime(event) >= now)
          .sort(
            (a, b) => new Date(a.scheduled_time) - new Date(b.scheduled_time)
          );

        setNextEvent(upcomingEvents[0] || null);
      } else {
        setNextEvent(null);
      }
    } catch (error) {
      setNextEvent(null);
    } finally {
      setLoading(false);
    }
  };

  const formatEventDateTime = dateString => {
    const eventDate = new Date(dateString);
    const now = new Date();
    const isToday = eventDate.toDateString() === now.toDateString();
    const isTomorrow =
      eventDate.toDateString() ===
      new Date(Date.now() + 86400000).toDateString();

    const time = eventDate.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    if (isToday) {
      return `Today ${time}`;
    } else if (isTomorrow) {
      return `Tomorrow ${time}`;
    } else {
      return `${eventDate.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
      })} ${time}`;
    }
  };

  return (
    <>
      <div
        className="rep-dashboard-bubble-card team-event-bubble"
        onClick={() => setModalOpen(true)}
      >
        <div className="rep-dashboard-bubble-icon event-icon">
          <IconCalendarEvent size={20} />
        </div>
        <div className="rep-dashboard-bubble-content">
          <span className="rep-dashboard-bubble-label">Next Event</span>
          <span className="rep-dashboard-bubble-value">
            {loading
              ? "Loading..."
              : nextEvent
                ? formatEventDateTime(nextEvent.scheduled_time)
                : "No upcoming events"}
          </span>
        </div>
      </div>

      {modalOpen && (
        <TeamEventsModal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  );
}

export default TeamEventBubble;
